export default {
    data() {
        return {
            forceEnableEditors: true
        };
    },
    mounted() {
        setTimeout(() => {
            this.forceEnableEditors = false;
        }, 500);
    }
};
